/**
 * GH#2318 — los avisos fijos de arriba (el amarillo «aún sin conexión real» y el rojo de prueba vencida)
 * NO pueden superponerse a la cabecera: tapaban el logo, el menú, la campana y el avatar (medido en
 * producción: el centro de la campana caía dentro del aviso, a 1440×900, 1280×720 y 390×844).
 *
 * El aviso amarillo mide lo que mide (su texto cambia por capacidad y por ancho), así que su altura NO se
 * escribe a mano: el propio aviso la publica en una variable CSS y el layout la suma. El aviso rojo ya tenía
 * su altura fija de 40 px y sigue contando igual.
 *
 * GH#2768 — la barra naranja «Estás viendo el workspace de … / Volver a Super Admin» es un TERCER aviso fijo. Estaba en `top-0` con z-110 y el
 * aviso amarillo (z-120) se le ponía encima: a 1366×900 el punto central del botón caía sobre el texto del aviso amarillo y el clic nunca llegaba.
 * Ahora va DEBAJO del amarillo, tiene alto fijo y lo publica en su propia variable, que este mismo cálculo suma.
 */
export const AVISO_DEMO_ALTO_VAR = '--aviso-demo-alto';
export const AVISO_SUPLANTACION_ALTO_VAR = '--aviso-suplantacion-alto';
export const ALTO_AVISO_PRUEBA_PX = 40;
export const ALTO_BARRA_SUPLANTACION_PX = 48;

/** Dónde se pega la barra de suplantación: justo debajo del aviso amarillo de modo demo (0 si no se ve). */
export const TOP_BARRA_SUPLANTACION = `var(${AVISO_DEMO_ALTO_VAR}, 0px)`;

/** Cuánto se baja todo lo que va pegado arriba (cabecera, barra lateral): avisos visibles, en px. */
export const desplazamientoPorAvisos = (hayAvisoPrueba: boolean): string =>
  `calc(var(${AVISO_DEMO_ALTO_VAR}, 0px) + var(${AVISO_SUPLANTACION_ALTO_VAR}, 0px) + ${hayAvisoPrueba ? ALTO_AVISO_PRUEBA_PX : 0}px)`;

/** Relleno superior del contenido: la cabecera (4rem = el `pt-16` de siempre) más los avisos. */
export const rellenoSuperiorDelContenido = (hayAvisoPrueba: boolean): string =>
  `calc(4rem + ${desplazamientoPorAvisos(hayAvisoPrueba)})`;

/** La barra de suplantación publica su alto (0 cuando no se ve) para que cabecera, barras laterales y contenido bajen debajo de ella. */
export const publicarAltoBarraSuplantacion = (px: number): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty(AVISO_SUPLANTACION_ALTO_VAR, `${Math.max(0, Math.round(px))}px`);
};

/** El aviso amarillo publica su alto real (0 cuando no se ve) para que el layout lo respete. */
export const publicarAltoAvisoDemo = (px: number): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty(AVISO_DEMO_ALTO_VAR, `${Math.max(0, Math.round(px))}px`);
};
